// apps/client/src/ui/items/SlotGrid.tsx — a grid of pocket or storage slots (DESIGN.md "HUD": cream-100 wells, icon at 68 %,
// quantity bottom-right, the selected slot ringed in leaf-700). Slot n of the grid shows the item whose `at.slot` is n.
import type { ItemView } from '@whiskerton/shared';
import { Slot } from '../kit';
import { useIcon } from './useIcon';

function Cell({ item, index, selected, onPick }: { item: ItemView | undefined; index: number; selected: boolean; onPick(i: ItemView | undefined): void }) {
  const icon = useIcon(item?.catalogId ?? null);
  return (
    <Slot label={`slot ${index + 1}`} qty={item?.qty} selected={selected} onClick={() => onPick(item)}>
      {item && <img src={icon} alt="" />}
    </Slot>
  );
}
export function SlotGrid({ items, slots, columns, selected, onPick }: {
  items: readonly ItemView[]; slots: number; columns: number; selected: string | null; onPick(i: ItemView | undefined): void;
}) {
  const bySlot = new Map(items.map((i) => [i.at.loc === 'pockets' || i.at.loc === 'storage' ? i.at.slot : -1, i]));
  return (
    <div className="slot-grid" style={{ display: 'grid', gridTemplateColumns: `repeat(${columns}, 1fr)`, gap: '1.1cqw' }}>
      {Array.from({ length: slots }, (_, n) => (
        <Cell key={n} index={n} item={bySlot.get(n)} selected={!!selected && bySlot.get(n)?.id === selected} onPick={onPick} />
      ))}
    </div>
  );
}
